import { TFunction } from '@lyearn/i18n';

export const getRatingLevels = (t: TFunction) => [
  { label: t('UserSurvey:QuestionSettings.EgPoor') },
  { label: t('UserSurvey:QuestionSettings.EgBad') },
  { label: t('UserSurvey:QuestionSettings.EgBetter') },
  { label: t('UserSurvey:QuestionSettings.EgGood') },
  { label: t('UserSurvey:QuestionSettings.EgAwesome') },
];

export const RATING_LEVELS = getRatingLevels((() => {}) as any).length;
